import React from 'react'
import style from './HowCard.module.css'
const HowCard = ({ steep, text }) => {
    return (
        <div className={style.card}>
            <div className={style.steep}>{steep}</div>
            <div className={style.text}>
                <div className={style.title}>{text.split(' ')[0]}</div>
                <div>{text.split(' ').slice(1).join(' ')}</div>
            </div>
        </div>
    )
}

export default HowCard